
const urlParams = new URLSearchParams(window.location.search);
const toast = urlParams.get('toast');
if(toast) {
    Toastify({
          text:
            toast,
          duration: 5000,
          newWindow: true,
          close: false,
          gravity: "bottom", // `top` or `bottom`
          position: "left", // `left`, `center` or `right`
          stopOnFocus: true, // Prevents dismissing of toast on hover
          style: {
            background: "white",
            color: "black",
            borderRadius: "8px",
          },
          onClick: function () {}, // Callback after click
        }).showToast()
}